import React from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Cell,
  Tooltip,
} from 'recharts';
import { Card } from '@common';
import { AppIcon } from '@common';
import { crossIcon } from '@src/assets/svg';
import CardFilters from 'components/specific/CardFilters';
import CardFiltersProvider from 'components/specific/CardFilters/context/filters-context';
import { CardFiltersContext } from 'components/specific/CardFilters/context/filters-context';

const colors = ['#375DFB', '#35B9E9', '#6E3FF3', '#F2AE40', '#E255F2'];

export const VisitedHos = ({ data, setLocalfiltersVisitedHospital }) => {
  return (
    <CardFiltersProvider>
      <VisitedHoss
        data={data}
        setLocalfiltersVisitedHospital={setLocalfiltersVisitedHospital}
      />
    </CardFiltersProvider>
  );
};

function VisitedHoss({ data, setLocalfiltersVisitedHospital }) {
  const ToolTip = ({ active, payload, coordinate }) => {
    if (!active || !payload || !payload.length) return null;

    const { x, y } = coordinate || {};

    return (
      <div
        className="absolute h-7 px-2.5 py-1 bg-[#20232d] rounded-md shadow-[0px_1px_2px_0px_rgba(228,229,231,0.24)] shadow-[0px_12px_24px_0px_rgba(134,140,152,0.12)] justify-center items-center gap-1.5 inline-flex text-white text-sm font-normal font-['Inter'] leading-tight
            before:content-[''] before:w-[0.69vw] before:h-[1.11vh] before:bg-[#20232d] before:absolute before:top-[22px] before:right-[20px] before:rotate-45"
        style={{
          left: x,
          top: y - 40,
          transform: 'translateX(-50%)',
          position: 'absolute',
          pointerEvents: 'none',
        }}
      >
        {payload?.[0]?.payload?.visit_count
          ? payload?.[0]?.payload?.visit_count
          : 2400}
      </div>
    );
  };

  const PieChartLine2 = ({ color = '#525866', className }) => {
    return (
      <svg
        className={`${className}`}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21C7.0293 21 3 16.9707 3 12C3 7.9698 5.6487 4.5588 9.3 3.4122V5.3238C7.75283 5.95204 6.47202 7.09834 5.67665 8.5666C4.88129 10.0349 4.62079 11.7339 4.93973 13.373C5.25866 15.0121 6.13721 16.4895 7.42509 17.5524C8.71297 18.6153 10.3301 19.1977 12 19.2C13.4344 19.2 14.8361 18.7716 16.0256 17.9699C17.215 17.1682 18.138 16.0296 18.6762 14.7H20.5878C19.4412 18.3513 16.0302 21 12 21ZM20.955 12.9H11.1V3.045C11.3961 3.0153 11.6967 3 12 3C16.9707 3 21 7.0293 21 12C21 12.3033 20.9847 12.6039 20.955 12.9ZM12.9 4.8558V11.1H19.1442C18.9439 9.51385 18.2216 8.0394 17.0911 6.90891C15.9606 5.77842 14.4862 5.05613 12.9 4.8558Z"
          fill={color}
        />
      </svg>
    );
  };

  const { state, dispatch, date } = React.useContext(CardFiltersContext);

  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  React.useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = {
        ...resultForParent,
        ...formatObject(state),
        local: true,
      };
    });

    setLocalfiltersVisitedHospital(resultForParent, date.dateState);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);

  return (
    <Card className="min-h-[464px] h-[100%] top-0 left-0 bg-white rounded-[20px] border border-solid border-[#e2e4e9]">
      <Card.Header className=" ">
        <div className="flex  items-center justify-between w-full gap-4 pl-4 pr-4">
          <div className="flex  items-start gap-2 px-0  pt-[23px] mb-[4px]">
            <PieChartLine2 className=" !w-6 !h-6 ml-[16px]" color="#525866" />
            <p className="text-[#0A0D14] font-[Inter] text-[16px] font-medium leading-[24px] tracking-[-0.176px]">
              Top 5 Visited Hospital
            </p>
          </div>
          <div>
            <CardFilters />
          </div>
        </div>

        {Object.entries(state[1]?.selectedList).length > 0 ? (
          <span className="ml-6 !bg-gray-200 text-grey-600   px-0.5	">
            <span className="dashboardFilters--showcase--selectedFilters--item--value">
              {state[1].title === 'Date'
                ? Object.values(state[1].selectedList || {}).join(',')
                : Object.keys(state[1].selectedList || {}).join(',')}
            </span>
            <AppIcon
              icon={crossIcon}
              onClick={() => {
                if (state[1].title === 'Date') {
                  date.removeDate();
                }
              }}
              className="dashboardFilters--showcase--selectedFilters--item--icon"
            />
          </span>
        ) : (
          console.log('state-have is empty', state[1])
        )}
      </Card.Header>
      <div className="w-full flex items-center justify-center ">
        <div className="bg-[#E2E4E9] h-[1px] rounded-full w-[95%]  box-border" />
      </div>

      <Card.Body className="ml-[10px] mt-[10px]">
        <div>
          <BarChart
            width={610}
            height={464}
            data={data}
            barSize={16}
            radius={[0, 0, 0, 0]}
            layout="vertical"
          >
            <CartesianGrid
              strokeDasharray="1 3"
              vertical={true}
              horizontal={false}
            />
            <XAxis
              type="number"
              dataKey="visit_count"
              axisLine={false}
              tickLine={false}
              tick={{
                fill: 'var(--text-soft-400, #868C98)',
                fontFamily: 'Inter',
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: '0.22px',
                textTransform: 'uppercase',
                textAnchor: 'middle',
              }}
            />{' '}
            <YAxis
              dataKey="hospital_name"
              type="category"
              width={120}
              axisLine={false}
              tickLine={false}
              tick={{
                fill: 'var(--text-sub-500, #525866)',
                fontFamily: 'Inter',
                fontSize: 14,
                fontWeight: 400,
                lineHeight: '20px',
                letterSpacing: '-0.084px',
                dx: -20,
              }}
            />
            <Tooltip content={<ToolTip />} />
            <Bar dataKey="visit_count">
              {data?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index]}
                  style={{ transition: 'none' }}
                  activeBar={false}
                />
              ))}
            </Bar>
          </BarChart>
        </div>
      </Card.Body>
    </Card>
  );
}

export default VisitedHos;
